import {Controller} from "stimulus"
import InView from "./../utils/InView"

export default class extends Controller {

    static targets = [
        "header",
        "burger",
    ]

    initialize() {

        this.fixedClassAdded = false

        new InView({
            element: this.headerTarget,
            offset: 0,
            withDirection: true,
            windowPosition: "top",
            withThrottle: false,
            inViewCallback: () => {
                if (!this.fixedClassAdded) {
                    this.headerTarget.classList.add("is-fixed")
                    this.fixedClassAdded = true
                }
            },
            inViewCallbackFromBottom: (data) => {
                if (this.fixedClassAdded) {
                    this.headerTarget.classList.remove("is-fixed")
                    this.fixedClassAdded = false
                }
            },
            notInViewCallback: (data) => {
                if (this.fixedClassAdded) {
                    this.headerTarget.classList.remove("is-fixed")
                    this.fixedClassAdded = false
                }
            },
            positionReference: () => 150,
            positionReferenceBack: () => 300,
        })

    }

    close(e) {
        e.preventDefault()
        this.headerTarget.classList.remove("is-active")
        this.burgerTarget.classList.remove("is-active")
    }

    open(e) {
        e.preventDefault()
        e.currentTarget.classList.add("is-active")
        this.headerTarget.classList.add("is-active")
        this.burgerTarget.classList.add("is-active")
    }

    toggle(e) {
        e.preventDefault()
        this.headerTarget.classList.toggle("is-active")
        this.burgerTarget.classList.toggle("is-active")
    }

}
